<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :model="selectForm" ref="selectFormRef" :inline="true" label-width="80px" class="font-bold">
        <!-- <el-form-item label="部门">
          <el-cascader
            size="small"
            :props="cascaderProps"
            v-model="selectedOptions"
            clearable
            @change="getServicers"
          ></el-cascader>

        </el-form-item> -->
        <el-form-item label="会员id" prop="member_id" >
          <el-input size="small" v-model="selectForm.member_id" clearable placeholder="请输入会员id"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="sid" >
          <el-input size="small" v-model="selectForm.sid" clearable placeholder="请输入工号"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" >
          <el-select class="width-100" size="small" v-model="selectForm.status" placeholder="请选择状态">
            <el-option
              v-for="item in options"
              size="small"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="margin-l-20">
          <el-button size="small"  @click="getServicers(true)">搜索</el-button>
          <el-button size="small" @click="resetInput">重置</el-button>
          <el-button size="small" type="primary" @click="addDialogVisible = true">新增客服</el-button>
        </el-form-item>
      </el-form>

      <!-- 客服列表区域 -->
      <el-table :data="servicerList" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="头像" prop="SenderImgurl" width="52">
          <template slot-scope="scope">
            <el-avatar
              :src="scope.row.ImgUrl"
              style="width: 30px; height: 30px"
            ></el-avatar>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="Name"></el-table-column>
        <el-table-column label="昵称" prop="Nickname"></el-table-column>
        <el-table-column label="ID" prop="ID"></el-table-column>
        <el-table-column label="工号" prop="Sid"></el-table-column>
        <el-table-column label="会员id" prop="MemberId"></el-table-column>
        <el-table-column label="部门名称" prop="DeptName"></el-table-column>
        <el-table-column label="在线状态" prop="Online">
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.Status - 0"
              v-model="scope.row.Online"
              @change="onlineChanged(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.Status"
              :active-value="1"
              :inactive-value="0"
              @change="stateChanged(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="CreateTime"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removePostById(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

<!--     添加客服的对话框-->
    <el-dialog title="添加客服" :visible.sync="addDialogVisible" width="30%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="客服姓名" prop="Name">
          <el-select ref="elSelect" class="width-100" v-model="addForm.Name" placeholder="请选择">
            <el-option
              :value="addForm.Name"
              style="height: auto"
            >
              <el-tree
                :props="props"
                :load="loadNode"
                @node-click="handleNodeClick"
                lazy>
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工号" prop="WxId">
          <el-input size="small" v-model="addForm.WxId" clearable placeholder="工号"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="Mobile">
          <el-input size="small" v-model="addForm.Mobile" clearable placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="在线状态" prop="Status">
            <el-switch
              v-model="addForm.Status"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
        </el-form-item>
        <el-form-item label="标签" prop="PostIds">
          <el-select
            v-model="addForm.PostIds"
            multiple
            placeholder="请选择标签">
            <el-option
              v-for="item in tagOptions"
              :key="item.Id"
              :label="item.PostName"
              :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPost">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改客服的对话框 -->
    <el-dialog title="修改客服" :visible.sync="editDialogVisible" width="30%" @close="editDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="editForm" ref="editFormRef" label-width="90px">
        <el-form-item label="客服姓名" prop="Name">
          <el-select ref="elEditSelect" class="width-100" v-model="editForm.Name" placeholder="请选择">
            <el-option
              :value="editForm.Name"
              style="height: auto"
            >
              <el-tree
                :props="props"
                :load="loadNode"
                @node-click="handleEditNodeClick"
                lazy>
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工号" prop="WxId">
          <el-input size="small" v-model="editForm.WxId" clearable placeholder="工号"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="Mobile">
          <el-input size="small" v-model="editForm.Mobile" clearable placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="在线状态" prop="Status">
            <el-switch
              v-model="editForm.Status"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
        </el-form-item>
        <el-form-item label="标签" prop="PostIds">
          <el-select
            v-model="editForm.PostIds"
            multiple
            placeholder="请选择标签">
            <el-option
              v-for="item in tagOptions"
              :key="item.Id"
              :label="item.PostName"
              :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editPostInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { chat_del, chat_get, chat_post, toForm } from '@/api'
  let id = 0;

  export default {
    name: 'customerSer',
    data() {
      return {
        // 获取客服列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },

        options: [{
          value: '0',
          label: '停用'
        }, {
          value: '1',
          label: '正常'
        }],
        editDialogVisible: false,
        selectForm: {
          dept_id: '',
          member_id: '',
          sid: '',
          status: ''
        },
        addFormRules: {
          Name: [
            { required: true, message: '请选择客服', trigger: 'blur' },
          ],
        },
        tagOptions: [],
        tagOptionsSelected: [],
        addForm: {
          Name: '',
          KFid: '',
          Sid: '',
          DeptId: '',
          Mobile: '',
          CodeUrl: '',
          WxId: '',
          Status: ''
        },
        servicerList: [],
        deptlist: [],
        total: 0,
        editForm: {
          Name: '',
          KFid: '',
          Sid: '',
          DeptId: '',
          Mobile: '',
          CodeUrl: '',
          WxId: '',
          Status: ''
        },
        // 控制添加客服对话框的显示与隐藏
        addDialogVisible: false,
        props: {
          label: 'DeptName',
          children: 'children',
          isLeaf: 'leaf'
        },
        selectedOptions: [],
        cascaderProps: {
          label: 'DeptName',
          leaf: 'NotHasChildren',
          checkStrictly: true,
          expandTrigger: 'hover',
          lazy: true,
          lazyLoad (node, resolve) {
            const { level } = node;
            if (level) {
              chat_get(`web/GetDeptListByPid?pid=${node.data.Id}`, {}, res => {
                resolve(res.data)
              })
            }else {
              chat_get('web/GetDeptListByPid?pid=0', {}, res => {
                resolve(res.data)
              })
            }
          }
        }
      }
    },
    created() {
      this.getServicers()
      this.addNew()
    },
    methods: {
      getServicers(val = false) {
        if (val) this.queryInfo.pagenum = 1;
        // let dept_id = this.selectedOptions.length && this.selectedOptions[this.selectedOptions.length-1]
        let { member_id, sid, status } = this.selectForm
        chat_get(`/admin/v1/kf?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&member_id=${member_id}&sid=${sid}&status=${status}`, {}, res => {
          if(res.status == 200) {
            let { List: servicerList, Total } = res.data.MessageContent
            this.total = Total
            this.servicerList = servicerList
          }
        })
      },
      handleNodeClick(sel) {
        // 如果不是最后一级则return
        if (sel.hasOwnProperty('Ancestors')) return;
        let { DeptName, main_department, mobile, qr_code, workNo, userid, Status, Online } = sel
        Status = Status || 0
        this.addForm = {
          Name: DeptName,
          Sid: workNo,
          Mobile: mobile,
          CodeUrl: qr_code,
          DeptId: main_department,
          WxId: userid,
          Status: Status + ''
        }
        this.$refs.elSelect.blur()
      },
      handleEditNodeClick(sel) {
        // 如果不是最后一级则return
        if (sel.hasOwnProperty('Ancestors')) return;
        let { DeptName, main_department, workNo, mobile, qr_code, userid, Status, Online } = sel;
        let ID = this.editForm.KFid;
        Status = Status || 0
        this.editForm = {
          Name: DeptName,
          KFid: ID,
          Sid: workNo,
          DeptId: main_department,
          Mobile: mobile,
          CodeUrl: qr_code,
          WxId: userid,
          Status: Status + ''
        }
        debugger
        this.$refs.elEditSelect.blur()
      },
      // 点击按钮，添加新客服
      addPost() {
        let params = toForm(this.addForm)
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          chat_post('admin/v1/kf', params, res => {
            if(res.data.hasOwnProperty('message'))  {
              this.$message.error(res.data.message)
            }else {
              this.$message.success('添加客服成功！')
              // 隐藏添加客服的对话框
              this.addDialogVisible = false
              // 重新获取客服列表数据
              this.getServicers()
            }
          })
        })
      },
      // 展示编辑客服的对话框
      showEditDialog(val) {
        chat_get(`/admin/v1/kfById?id=${val.ID}`, {}, res => {
          if(res.status == 200) {
            this.editForm = res.data.MessageContent.KfInfo
            this.$set( this.editForm, 'PostIds', res.data.MessageContent.TagInfo || '')
            this.editForm.KFid = val.ID
          }
        })
        this.editDialogVisible = true
      },
      onlineChanged(row) {
        this.$confirm( `确定${ row.Online ? '上线' : '下线' }该客服吗？`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_post(`/admin/v1/kf/force/onoff`, {
            online: row.Online,
            member_id: row.MemberId
          }, res => {
            if(res.data.MessageType === 1) {
              this.$message.success(res.data.MessageContent)
              this.getServicers()
            }
          })
        }).catch(() => {
          row.Online = !row.Online
        })
      },
      stateChanged(value) {
        let params = toForm({
          KFid: value.ID,
          Status: value.Status,
          Sid: value.Sid
        })
        chat_post('/admin/v1/upKf', params, res => {
          if(res.status == 200 && res.data.hasOwnProperty('message')) {
            this.$message.error(res.data.message)
          }else {
            // 关闭对话框
            this.editDialogVisible = false
            // 提示修改成功
            this.$message.success('更新状态成功！')
          }

          // 刷新数据列表
          this.getServicers()
        }, () => {
          value.Status = !value.Status
        })
      },
      loadNode(node, resolve) {
        // 最后一级
        if(node.data && node.data.NotHasChildren) return;
        if (node.level === 0) {
          chat_get(`/admin/deptList?Id=1`, {}, res => {
            if(res.status == 200) {
              return resolve(res.data.MessageContent)
            }
          })
        }
        if (node.level > 0) {
          chat_get(`/admin/getDeptAndUserByPid?id=${node.data.Id}`, {}, res => {
            if (res.status == 200) {
              let list = []
              let { DeptList, UserList } = res.data
              list = DeptList ? DeptList : []
              list = UserList ? list.concat(UserList) : list
              return resolve(list)
            }
          })
        }
      },
      addNew() {
        chat_get('admin/v1/sysPostList', {}, res => {
          if(res.status == 200) {
            this.tagOptions = res.data.MessageContent
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getServicers()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getServicers()
      },
      // 监听添加客服对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },

      // 监听修改客服对话框的关闭事件
      editDialogClosed() {
        this.$refs.editFormRef.resetFields()
      },
      // 修改客服信息并提交
      editPostInfo() {
        let vm = this;
        this.$refs.editFormRef.validate(valid => {
          if (!valid) return
          let {KFid,Sid,DeptId,Name,Mobile,PostIds = '', WxId} = vm.editForm;
          console.log(this.editForm)
          let params = toForm({
            KFid,Sid,DeptId,Name,Mobile,PostIds,WxId
          })
          chat_post('/admin/v1/upKf', params, res => {
            if(res.status == 200 && res.data.hasOwnProperty('message')) {
              this.$message.error(res.data.message)
            }else {
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getServicers()
              // 提示修改成功
              this.$message.success('更新客服信息成功！')
            }
          })
        })
      },
      resetInput() {
        this.$refs.selectFormRef.resetFields()
        this.getServicers()
      },
      // 根据Id删除对应的客服信息
      removePostById(oneUser) {
        let vm = this;
        this.$confirm( `此操作将删除"${oneUser.Name}"客服, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_del(`/admin/v1/kf/${oneUser.ID}`, {}, res => {
            if(res.status == 200) {
              vm.getServicers()
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }
          })
        }).catch(() => {
          oneUser.Status = !oneUser.Status
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
    }
  }
</script>

<style scoped>
  .el-select-dropdown__item {
    padding: 0;
    text-align: center;
  }
</style>
